import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, endpoints } from '../../api';
import NewApplicationPage from '../../pages/NewApplicationPage';
import { ApplicationFormType } from '../../pages/NewApplicationPage/types';

export const EditApplicationPage = () => {
  const [currentApplicationState, setCurrentApplication] = useState<ApplicationFormType | undefined>();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const response = await api.get<ApplicationFormType>(endpoints.getApplicationById(id));

          setCurrentApplication(response.data);
        } catch (err) {}
      })();
    }
  }, [id]);

  return (
    <>
      <NewApplicationPage newApplication={currentApplicationState} edit></NewApplicationPage>
    </>
  );
};
